import React from 'react'

import { Hr, MediumText, SmallText } from 'src/utils/styles/global-styles'
import { Image, TabTitle } from './styles'

const Captions = () => (
  <>
    <TabTitle>Captions</TabTitle>
    <MediumText>You add captions to your photos from the mobile app.</MediumText>

    <Hr />

    <MediumText>To add captions from the app, follow these steps:</MediumText>
    <SmallText>
      1. Log in to the app and click on the name of the frame you wish to send a photo to.
    </SmallText>
    <SmallText>2. Click the arrow icon on the top right corner.</SmallText>
    <Image
      alt="Send Photos Icon"
      src="https://i.shgcdn.com/790423f3-0379-4f27-b4e6-18339acdfe14/-/format/auto/-/preview/3000x3000/-/quality/lighter/"
    />

    <SmallText>3. Pick a photo from your gallery or use your camera to take a new one!</SmallText>
    <SmallText>4. Type your caption in the gray box and click "send".</SmallText>
  </>
)

export default Captions
